import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '@/app/layout/Sidebar.css';

/**
 * Navigation item definition for the sidebar.
 */
interface NavItem {
  readonly to: string;
  readonly icon: string;
  readonly labelKey: string;
}

const NAV_ITEMS: readonly NavItem[] = [
  { to: '/', icon: 'space_dashboard', labelKey: 'nav.dashboard' },
  { to: '/chart', icon: 'bar_chart_4_bars', labelKey: 'nav.chart' },
  { to: '/positions', icon: 'pin_drop', labelKey: 'nav.positions' },
  { to: '/members', icon: 'group', labelKey: 'nav.members' },
  { to: '/settings', icon: 'settings', labelKey: 'nav.settings' },
  { to: '/info', icon: 'info', labelKey: 'nav.info' },
];

/**
 * Persistent sidebar navigation for desktop viewports.
 * Shows nav items with icons and labels, highlighting the active route.
 * A subtle Terms & Conditions link is pinned to the bottom.
 */
function Sidebar() {
  const { t } = useTranslation('common');

  return (
    <aside className="sidebar" aria-label={t('nav.mainNavigation')}>


      <nav>
        <ul className="sidebar-nav" role="list">
          {NAV_ITEMS.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `sidebar-nav-item${isActive ? ' sidebar-nav-item-active' : ''}`
                }
              >
                <span className="material-symbols-rounded sidebar-nav-icon" aria-hidden="true">
                  {item.icon}
                </span>
                <span>{t(item.labelKey)}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Spacer pushes the legal link to the bottom */}
      <div className="sidebar-spacer" />
    </aside>
  );
}

export { Sidebar };

